import './utils/polyfills';

// Initialize Sentry
import { initSentry } from './utils/sentry';
initSentry();

// Boot up app
import { render } from 'preact';
import { hydrate, prerender as ssr } from 'preact-iso';
import { App } from './components/app';
import './style/00_reset.css';
import './style/01_index.css';
import './style/02_buttons.scss';

// Hydrate app
if (typeof window !== 'undefined') {
  if (document.title.startsWith('404 Not Found')) {
    // If 404 page is served up but matches a client-side route, we don't want to hydrate
    // This happens locally when previewing /podcast routes
    render(<App />, document.getElementById('app')!);
    console.warn('Not hydrating 404 page');
  } else {
    hydrate(<App />, document.getElementById('app')!);
  }
}

// Register service worker
if (typeof window !== 'undefined') {
  import('./service-worker/register-and-update');
}

export async function prerender(data) {
  const { html, links } = await ssr(<App {...data} />);

  // Docs: https://preactjs.com/blog/prerendering-preset-vite/
  // Really cool implementation :)
  return { html, links, head: { title: globalThis.pageTitle } };
}
